module.exports = __webpack_public_path__ + "Lato-Black.33d5f0d956f3fc30bc51.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Black.woff2
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Black.woff2
// module chunks = styles